import * as React from "react"
import type { GatsbyBrowser } from "gatsby"
import { config as faConfig } from "@fortawesome/fontawesome-svg-core"

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
    // FontAwesome inspired by https://github.com/jzabala/gatsby-plugin-fontawesome-css
    faConfig.autoAddCss = false
}